module.exports={
	"Form": "SampleStatusEditManifest",
	"Scope": "SampleStatus-Edit",
	"Descriptors":
	{
		"SampleStatusDetails.Name":
		{
			"Name": "Name",
			"Hash": "SampleStatus-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "SampleStatus-Edit-Identity",
				"Group": "SampleStatus-Edit-Identity"
			}
		},
		"SampleStatusDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "SampleStatus-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "SampleStatus-Edit-Details",
				"Group": "SampleStatus-Edit-Details"
			}
		},
		"SampleStatusDetails.Description":
		{
			"Name": "Description",
			"Hash": "SampleStatus-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "SampleStatus-Edit-Details",
				"Group": "SampleStatus-Edit-Details"
			}
		},
		"SampleStatusDetails.Category":
		{
			"Name": "Category",
			"Hash": "SampleStatus-Edit-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-Edit-Details",
				"Group": "SampleStatus-Edit-Details"
			}
		},
		"SampleStatusDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "SampleStatus-Edit-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-Edit-Details",
				"Group": "SampleStatus-Edit-Details"
			}
		},
		"SampleStatusDetails.IDSampleStatus":
		{
			"Name": "IDSample Status",
			"Hash": "SampleStatus-Edit-IDSampleStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		},
		"SampleStatusDetails.GUIDSampleStatus":
		{
			"Name": "GUIDSample Status",
			"Hash": "SampleStatus-Edit-GUIDSampleStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		},
		"SampleStatusDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "SampleStatus-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		},
		"SampleStatusDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "SampleStatus-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		},
		"SampleStatusDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "SampleStatus-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		},
		"SampleStatusDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "SampleStatus-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "SampleStatus-Edit-DataAudit",
				"Group": "SampleStatus-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "SampleStatus-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "SampleStatus-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "SampleStatus-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "SampleStatus-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "SampleStatus-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "SampleStatus-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
